import {
  ChannelOption,
  HealthBenefitLanguageOptionsValue,
  CommunicationLanguageOptionsValue
} from '../../../../../@types/Marketing';

export const marketingLanguageOptions: { label: string; value: keyof typeof CommunicationLanguageOptionsValue }[] = [
  {
    label: 'English only',
    value: CommunicationLanguageOptionsValue.ENGLISH_ONLY
  },
  {
    label: 'English-Spanish',
    value: CommunicationLanguageOptionsValue.ENGLISH_SPANISH
  },
  {
    label: 'Spanish only',
    value: CommunicationLanguageOptionsValue.SPANISH_ONLY
  },
  {
    label: 'English-French',
    value: CommunicationLanguageOptionsValue.ENGLISH_FRANCH
  },
  {
    label: 'French only',
    value: CommunicationLanguageOptionsValue.FRENCH_ONLY
  }
];

export const healthBenefitLanguageOptions: { label: string; value: keyof typeof HealthBenefitLanguageOptionsValue }[] =
  [
    {
      label: 'Made available by',
      value: HealthBenefitLanguageOptionsValue.MADE_AVAILABLE
    },
    {
      label: 'A benefit provided by',
      value: HealthBenefitLanguageOptionsValue.BENEFIT_PROVIDED
    },
    {
      label: 'This program is provided by',
      value: HealthBenefitLanguageOptionsValue.PROGRAM_PROVIDED
    },
    {
      label: 'Do not show',
      value: HealthBenefitLanguageOptionsValue.DO_NOT_SHOW
    }
  ];

export const permToTestOptions = {
  label: 'Permission to test',
  checkedValue: ChannelOption.YES,
  options: [
    {
      label: 'Yes',
      value: ChannelOption.YES
    },
    {
      label: 'No',
      value: ChannelOption.NO
    }
  ]
};
